import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController, LoadingController } from '@ionic/angular';
import { ChatService } from 'src/app/services/chat.service';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-mdl-bandeja-agente',
  templateUrl: './mdl-bandeja-agente.page.html',
  styleUrls: ['./mdl-bandeja-agente.page.scss'],
})
export class MdlBandejaAgentePage implements OnInit {

  @Input() idAdmin;
  @Input() url_back;
  @Input() url
  @Input() classId
  @Input() rol
  @Input() token
  @Input() idAgente
  @Input() idNumeroWhatssapp
  @Input() leads;
  @Input() conversacion;
  @Input() agente: string;
  @Input() cliente: string;
  loading: HTMLIonLoadingElement;
  elemento: HTMLElement;
  mensajes
  nombreArchivo
  enlaceDescarga
  @ViewChild('content') private content: any;
  constructor( public modalController: ModalController,
               public chat: ChatService,
               public waServ: WhatsappService,
               private formatdate: DatePipe,
               public loadingController: LoadingController,
               ) {
                this.mensajes = null
               }

  ngOnInit() {
// console.log(this.idNumeroWhatssapp, this.idAgente)
    if(this.leads) {
      this.consultarChatsInComp();
    } else {
      this.consultarHistorialChats();
    }
  }

  consultarChatsInComp(){

    const quer = {
      id_admin: this.idAdmin,
      id_cliente: this.idNumeroWhatssapp,
      conversacion: this.conversacion
    }

    this.waServ
    .getChatInCompl(quer, this.classId, this.rol,
      this.token, this.url_back)
    .subscribe((msg) => {

      console.log(msg);

      // msg['chat'].forEach((element) => {
      //   this.mensajes.push(element);
      // });
      this.mensajes = msg['chats']

     this. scrollToBottomOnInit()

    })

    //console.log(this.mensajes);
  }


  consultarHistorialChats(){

    this.chat
    .getConversacionesDeNumero(this.idAdmin, this.idAgente, this.idNumeroWhatssapp, this.classId, this.rol,
      this.token, this.url_back)
    .subscribe((msg) => {

      console.log(msg);
      console.log(this.chat)

      // msg['chat'].forEach((element) => {
      //   this.mensajes.push(element);
      // });
      this.mensajes = msg['chat']
      console.log(this.mensajes)

     this. scrollToBottomOnInit()

    })

    console.log(this.mensajes);
  }

  descargar() {
    this.presentLoading('Descargando datos...');
    if (this.mensajes.length > 0) {
      const primerMensaje = this.mensajes[0];
      const dataParaExcel = this.mensajes.map(msg => {
        const fechaFormateada = this.formatdate.transform(msg.createdAt, 'dd/MM/yyyy HH:mm:ss');
        
        return {
          Telefono: msg.numero.numeroCliente,
          'Nombre Usuario': msg.usuario 
            ? `${msg.usuario.nombre} ${msg.usuario.apellido || ''}` 
            : '',
          'Fecha de envío': fechaFormateada,
          Mensaje: msg.mensaje,
          'Enviado Por': msg.autor,
          Agente: msg.agente
            ? `${msg.agente.nombre} ${msg.agente.apellido || ''}`
            : '',
        };
      });
  
      const fechaArchivo = this.formatdate.transform(new Date(), 'dd-MM-yyyy-HH-mm-ss');
      const numeroConversacion = primerMensaje.numero.numeroCliente;
      const nombreAgente = primerMensaje.agente?.nombre ?? 'desconocido'; 
      const nombreArchivo = `chat-${nombreAgente}-${numeroConversacion}-${fechaArchivo}`;
  
      this.waServ.exportAsExcelFile(dataParaExcel, nombreArchivo);
      console.log(dataParaExcel);
    } else {
      console.warn('No hay mensajes en this.mensajes');
    }
  }
  
  descargarArchivo(url) {
    // console.log(url);
    window.location.href = url;
  }


  cerrarModal() {
    this.modalController.dismiss();
}

  revisarImgSrc(mensaje) {
    this.nombreArchivo = null;
    const mensaje1 = mensaje.split('.');
    //console.log(mensaje1[0])
    if (mensaje1[0] === 'https://planitwhatsapp' && mensaje1[1] === 's3') {
      this.enlaceDescarga = mensaje;

      const indiceFormato = mensaje1.length - 1;
      const indiceNombreArchivocompleto = mensaje1.length - 2;
      const nombreArchivoCompleto = mensaje1[indiceNombreArchivocompleto];
      const arrayNombreCompletoArchivo = nombreArchivoCompleto.split('-');
      const indiceNombrArchivo = arrayNombreCompletoArchivo.length - 1;

      let tipoArchivo = mensaje1[indiceFormato];
      //'jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG'

      //console.log(tipoArchivo)

      if(tipoArchivo.split('%')[0] ==='ogg'){
          tipoArchivo = 'ogg';
      }

      //-----------si es imagen--------------------------------------------------
      if (
        tipoArchivo === 'jpg' ||
        tipoArchivo === 'png' ||
        tipoArchivo === 'jpeg' ||
        tipoArchivo === 'JPG' ||
        tipoArchivo === 'PNG' ||
        tipoArchivo === 'JPEG'
      ) {
        return 1;
      }

      //----------------------si es video-------------------------------------------

      if (
        tipoArchivo === 'MP4' ||
        tipoArchivo === 'mp4' ||
        tipoArchivo === '3gp' ||
        tipoArchivo === '3GP'
      ) {
        this.nombreArchivo =
          arrayNombreCompletoArchivo[indiceNombrArchivo] + '.' + tipoArchivo;
        return 3;
      }



         //----------------------si es audio-------------------------------------------

         if (
          tipoArchivo === 'ogg'
        ) {
          this.nombreArchivo =
            arrayNombreCompletoArchivo[indiceNombrArchivo] + '.' + tipoArchivo;
          return 4;
        }



      //--------------------si es archivo------------------------------------------------------------
      else {
        this.nombreArchivo =
          arrayNombreCompletoArchivo[indiceNombrArchivo] + '.' + tipoArchivo;

        return 2;
      }
    }
    else if(mensaje1[0] ==='https://maps'){
//console.log('cae caso de latitud')
    return 5

    }

    else return 0;


  }


  scrollListVisible() {
    // console.log('entra funcion de scroll')
    // this.elemento = document.getElementById('chat-mensajes');
    //  console.log(this.elemento.scrollTop, this.elemento.scrollHeight,);
    // setTimeout(() => {
    //    this.elemento.scrollTop = this.elemento.scrollHeight;
    // console.log('se detona scroll')
    // console.log(this.elemento.scrollTop, this.elemento.scrollHeight,);
    //  }, 5000);




  }
  scrollToBottomOnInit() {
    // this.elemento = document.getElementById('chat-mensajes');
    // this.content.scrollToBottom(this.elemento.scrollHeight);
    setTimeout(() => {
      if (this.content.scrollToBottom) {
          this.content.scrollToBottom(400);
      }
  }, 500);
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',

      // message: mensaje,
      cssClass: 'loaderGeneral',
      message: '<ion-img src="../../../assets/images/logoVabelLoading.png"></ion-img>',
      duration: 3000
    });
    await this.loading.present();
  }
}
